import { APP_ENVS } from '@savgroup-front-common/constants/shared';

export const NEW_TRANSLATIONS_ENABLED_ENVS: APP_ENVS[] = [
  APP_ENVS.LOCAL,
  APP_ENVS.DEV,
  APP_ENVS.DEMO,
];

export const TRANSLATIONS_DIRECTORY = 'translations';
export const NEW_TRANSLATIONS_DIRECTORY = 'new-translations';
export const FALLBACK_TRANSLATIONS_DIRECTORY = 'static';

export const TRANSLATION_SCOPE = {
  STATIC: '',
  DYNAMIC: 'dynamic/',
} as const;

export type TranslationScope =
  (typeof TRANSLATION_SCOPE)[keyof typeof TRANSLATION_SCOPE];

export interface IntlManagerResponseSuccess {
  value: Record<string, string>;
  failure: false;
}

export interface IntlManagerResponseFailure {
  failure: true;
}

export type IntlManagerResponse =
  | IntlManagerResponseSuccess
  | IntlManagerResponseFailure;

export interface BuildTranslationUrlArgs {
  directory: string;
  scope: TranslationScope;
  locale: string;
}

export interface FetchTranslationsArgs {
  scope: TranslationScope;
  locale: string;
}
